'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

require('./FormInput.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INPUT_PROPS = [
// HTML attributes
'placeholder', 'type', 'value', 'defaultValue', 'selected', 'checked',
// Event listeners
'onBlur', 'onChange', 'onFocus'];

var RadioInput = function RadioInput(props) {
    var name = props.name,
        value = props.value,
        fields = props.fields,
        className = props.className,
        sanitisedErrors = props.sanitisedErrors,
        onChange = props.onChange;

    var field = fields[name];

    var isError = sanitisedErrors[name] && sanitisedErrors[name].showError;

    return _react2.default.createElement('input', _extends({ id: name
    }, (0, _lodash.pick)(props, INPUT_PROPS), (0, _lodash.pick)(field, INPUT_PROPS), {
        value: value,
        checked: field.value === value,
        name: name,
        type: 'radio',
        onChange: onChange(name),
        className: (0, _classnames2.default)('RadioInput', className, { error: isError }) }));
};

RadioInput.propTypes = {
    name: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.string.isRequired,
    fields: _propTypes2.default.object.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    sanitisedErrors: _propTypes2.default.object,
    className: _propTypes2.default.string,
    noName: _propTypes2.default.bool,
    valueFormatter: _propTypes2.default.func,
    checked: _propTypes2.default.bool
};

exports.default = RadioInput;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/form/fields/RadioInput.js
// module id = 1776
// module chunks = 0